module.exports = __webpack_public_path__ + "media/26 for the sake of.9e32b7ae.mp3";